<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/5start#chap1"><i>Introduction</i></a></p>
<p class="toc1"><a href="#/6chap2#chap2"><i>Finn and the Snakes</i></a></p>
<p class="toc1"><span href="#/7chap3#chap3" title="Link target outside of Sample"><i>Finn Serves the Salmon</i></span></p>
<p class="toc1"><span href="#/8chap4#chap4" title="Link target outside of Sample"><i>The Winter Burning</i></span></p>
<p class="toc1"><span href="#/9chap5#chap5" title="Link target outside of Sample"><i>The Scroll of Debts</i></span></p>
<p class="toc1"><span href="#/10chap6#chap6" title="Link target outside of Sample"><i>The Boar of Ballinoe</i></span></p>
<p class="toc1"><span href="#/11chap7#chap7" title="Link target outside of Sample"><i>Houlihan’s Barn</i></span></p>
<p class="toc1"><span href="#/12chap8#chap8" title="Link target outside of Sample"><i>Hanratty’s Hunger</i></span></p>
<p class="toc1"><span href="#/13chap9#chap9" title="Link target outside of Sample"><i>Finn and Goll</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4TOC.vue?7973af14